import { Component, Input, AfterViewInit, ViewChildren, ViewChild, QueryList, ContentChild, OnInit, ChangeDetectorRef, ChangeDetectionStrategy, ContentChildren, forwardRef} from '@angular/core';
import { TableHeaderComponent } from '../table-header/table-header.component';
import { TableColumnComponent } from '../table-column/table-column.component';
import { TableRowComponent } from '../table-row/table-row.component';
import { TableDropdownSectionComponent } from '../table-dropdown-section/table-dropdown-section.component';


@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TableComponent implements AfterViewInit {
  @Input() columns!: string;
  @Input("has-additional") hasAdditional: false; 

  @ContentChild(TableHeaderComponent) header!: TableHeaderComponent;
  
  tableRows: TableRowComponent[] = [];

  // @ContentChildren(TableDropdownSectionComponent) tableDropdowns: QueryList<TableDropdownSectionComponent>;

  constructor(private changeDetector: ChangeDetectorRef) {

  }

  ngAfterViewInit() {
      
    // if (this.tableRows.some(tableRow => !!tableRow.href)) {
      //   this.header.columnCount++;
      //   columnSizes.push("60px");
      // }
      
    if (this.header) {
      this.header.hasAdditional = this.hasAdditional;

      if (this.header.columns) {
        const columnSizes = this.header.columns.map(c => c.size);
        this.columns = columnSizes.join(" ");
      }
    } else {
      this.columns = this.tableRows[0].columns.map(c => c.size).join(" ");
    }

    this.changeDetector.detectChanges();
  }
}
